module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/img_doctor-a54f5cbcffaf7508e99624eff92c7760.png";